import { IAppState } from '../../../AppModulesWrapper';
import { selectIsServicesEnabled } from '../../reducers/v2/promotion/selectors';

export const selectIsWithoutServices = (state: IAppState): boolean => {
  return !selectIsServicesEnabled(state);
};
